import React from "react";
import './dialog.scss'

export function Dialog({children}: any) {
    return <div className="dialogWrapper">{children}</div>
}

<Dialog>
    
</Dialog>